import Seat from "../models/Seat";
import Table from "../models/Table";
import Player from "../models/Player";
import Hand from "../models/Hand";
import Message from "../models/Message";

const mapToSeat = (doc) => {
    if (!doc) return null;

    const id = doc.number;
    const number = doc.number;
    const playerId = doc.playerId;
    const name = doc.name;
    const card1 = doc.card1;
    const card2 = doc.card2;
    const isPlaying = doc.isPlaying;
    const isDealer = doc.isDealer;
    const inGame = doc.inGame;
    const status = doc.status;
    const playerMoney = doc.playerMoney;
    const bet = doc.bet;
    const prize = doc.prize;
    const timestamp = doc.timestamp;
    const sitOutTime = doc.sitOutTime;

    return new Seat(id, number, playerId, name, card1, card2, isPlaying, isDealer, inGame, status, playerMoney, bet, prize, timestamp, sitOutTime);
}

const mapToTable = (doc) => {
    if (!doc?.data()) return null;

    const id = doc.id;
    const name = doc.data().name;
    const bigBlind = doc.data().bigBlind;
    const smallBlind = doc.data().smallBlind;
    const playersNumber = doc.data().playersNumber;
    const seatsNumber = doc.data().seatsNumber;
    const pot = doc.data().pot;
    const card1 = doc.data().card1;
    const card2 = doc.data().card2;
    const card3 = doc.data().card3;
    const card4 = doc.data().card4;
    const card5 = doc.data().card5;
    const timeLimit = doc.data().timeLimit;
    const winnerCards = doc.data().winnerCards;
    const sitOutTimeLimit = doc.data().sitOutTimeLimit;

    return new Table(id, name, bigBlind, smallBlind, playersNumber, seatsNumber, pot, card1, card2, card3, card4, card5, timeLimit, winnerCards, sitOutTimeLimit);
}

const mapToPlayer = (doc) => {
    if (!doc?.data()) return null;

    const id = doc.id;
    const name = doc.data().name;
    const money = doc.data().money;
    const address = doc.data().address;
    const tableId = doc.data().tableId;

    return new Player(id, name, money, address, tableId);
}

const mapToHand = (doc) => {
    if (!doc?.data()) return null;

    const playerId = doc.data().playerId;
    const card1 = doc.data().card1;
    const card2 = doc.data().card2;

    return new Hand(playerId, card1, card2);
}

const mapToMessage = (doc) => {
    if (!doc?.data()) return null;

    const id = doc.id;
    const playerId = doc.data().playerId;
    const playerName = doc.data().playerName;
    const createdAt = doc.data().createdAt;
    const message = doc.data().message;

    return new Message(id, playerId, playerName, createdAt, message);
}

export {mapToSeat, mapToTable, mapToPlayer, mapToHand, mapToMessage}
